import React, { useEffect, useState, useCallback } from "react";
import ContentArea from '../components/content-area/Content';
import RecognitionPng from "../assets/icons/recognition.png";
import { getPredefinedComments } from "../api/recognitionApi";
import CommentList from "../components/recognition/CommentList";
import { useSpaceId } from "../hooks/useSpaceId";
import { signalRService } from "../services/signalRService";
import { SIGNALR_EVENTS } from '../constants/signalREvents';
import { CONTENT_TYPES } from '../constants/contentTypes';

// TODO: remove once backend returns contentStatus + proper approvalStatus fields.
const normalizeComment = (c) => {
  if (c.contentStatus) return c; 
  return {
    ...c,
    contentStatus: 'draft',
    approvalStatus: c.approvalId ? c.approvalStatus : null,
  };
};

function Recognition() {
  const spaceId = useSpaceId();
  const [comments, setComments] = useState([]);

  const loadComments = useCallback(async () => {
    try {
      const data = await getPredefinedComments();
      // getPredefinedComments requests includeInactive so approval snapshots can
      // still resolve their base record; a direct delete soft-deletes (isActive:
      // false) rather than removing the row, so drop those before rendering —
      // otherwise a "deleted" comment keeps showing up in every status tab.
      setComments(data.filter((c) => c.isActive !== false).map(normalizeComment));
    } catch (err) {
      console.error('[Recognition] load error', err);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!spaceId) return;
    loadComments();
  }, [spaceId, loadComments]);

  useEffect(() => {
    const handle = (payload) => {
      if (payload?.contentType === CONTENT_TYPES.RECOGNITION) loadComments();
    };
    signalRService.on(SIGNALR_EVENTS.APPROVAL_DECISION, handle);
    signalRService.on(SIGNALR_EVENTS.APPROVAL_WITHDRAWN, handle);
    return () => {
      signalRService.off(SIGNALR_EVENTS.APPROVAL_DECISION, handle);
      signalRService.off(SIGNALR_EVENTS.APPROVAL_WITHDRAWN, handle);
    };
  }, [loadComments]);

  return (
    <ContentArea title="Recognition" icon={RecognitionPng}>
      <CommentList comments={comments} onSuccess={loadComments} />
    </ContentArea>
  );
}

export default Recognition;
